import * as constants from '../../constants';

export const NAME = `${constants.NAME}/bulkedit`;
export const MODULE_PATH = NAME.split('/');
